import React from "react";

/**
 * Voxly logo — bold letter "V" inside the orange tile, flanked by
 * radiating sound waves on both sides. Used as both the app icon
 * (square tile) and inline alongside the wordmark.
 */
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-hidden
    >
      <defs>
        <linearGradient id="voxly-tile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="hsl(15 100% 60%)" />
          <stop offset="100%" stopColor="hsl(8 95% 50%)" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#voxly-tile)" />

      {/* Sound waves — left side */}
      <path d="M 8 24 Q 4 32 8 40" stroke="white" strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.55" />
      <path d="M 14 20 Q 9 32 14 44" stroke="white" strokeWidth="2.4" fill="none" strokeLinecap="round" opacity="0.85" />

      {/* Sound waves — right side */}
      <path d="M 56 24 Q 60 32 56 40" stroke="white" strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.55" />
      <path d="M 50 20 Q 55 32 50 44" stroke="white" strokeWidth="2.4" fill="none" strokeLinecap="round" opacity="0.85" />

      {/* Bold letter V */}
      <path
        d="M 21 18 L 32 46 L 43 18"
        stroke="white"
        strokeWidth="6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Full lockup: logo tile + Voxly wordmark. */
export default function Logo({ size = 36, showWord = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoMark size={size} />
      {showWord && (
        <span className="font-heading font-black tracking-tight" style={{ fontSize: Math.round(size * 0.6) }}>
          Voxly
        </span>
      )}
    </div>
  );
}
